module.exports = __webpack_public_path__ + "static/brent-894300d936291fae95e260e9f173bf93.jpg";